import React, { useEffect, useState } from "react";
import { getService } from "../../../services/axios/services";
import SimpleScriptBox from "../../ProjectSheet/SimpleScriptBox/SimpleScriptBox";
import AddAttachments from "../NewActivity/AddAttachments/AddAttachments";
import AttachmentIcon from "../../../components/VectorIcons/AttachmentIcon";
import EditModalActivity from "./EditActivity/EditModalActivity";
import { useCompiledAttachments } from "../../../hooks/useCompiledAttachments";
import { getAttachmentSelectionKey } from "../../../utils";
import {
  flatMapFilesAndVersions,
  getChapterOrEpisodeType,
} from "../NewActivity/newActivity.utils";

const returnInfo = (activity) => {
  return {
    title: activity.data.contentTitle,
    creators: activity.data.creators,
    format: activity.data.format,
    category: !!activity.data.subCategory
      ? activity.data.subCategory.value
      : "",
    subCategory: !!activity.data.subCategory
      ? activity.data.subCategory.category.value
      : "",
    description: activity.data.description,
  };
};

const EditActivity = (props) => {
  const { currentActivity, type, _getActvity, open } = props;

  const [stateProjectAttachment, setStateProjectAttachment] = useState({
    loading: true,
    files: [],
  });

  const [stateActivityAttachment, setStateActivityAttachment] = useState({
    loading: true,
    files: [],
  });

  const [stateSelectFiles, setStateSelectFiles] = useState(false);
  const [stateContentInfo, setStateContentInfo] = useState({
    loading: true,
    info: {},
  });

  const {
    toggleActiveCheckBox,
    toggleActiveVersionCheckBox,
    clearActive,
    resetSelection,
    compile,
    stateFiles,
  } = useCompiledAttachments({ groupSupplementaryMaterial: true });

  const getAttachmentsProjects = () => {
    getService({
      endpoint: `contents/${currentActivity.projectId}/attachments`,
    }).then((activity) => {
      setStateProjectAttachment({
        ...stateProjectAttachment,
        loading: false,
        files: activity.data.attachments,
      });
    });
  };

  const getAttachmentsActivity = () => {
    getService({ endpoint: `activities/${currentActivity.id}` }).then(
      (activity) => {
        setStateActivityAttachment({
          ...stateActivityAttachment,
          loading: false,
          files: activity.data.attachments,
        });
        setStateContentInfo({
          loading: false,
          info: returnInfo(activity),
        });
      }
    );
  };

  const setActiveAttachments = (rawFiles) => {
    const files = flatMapFilesAndVersions(rawFiles);
    const activeFileIds = new Set(
      stateActivityAttachment.files.map((item) => item.fileId)
    );
    const seedKeys = files
      .filter((file) => activeFileIds.has(file.fileId))
      .map((file) => getAttachmentSelectionKey(file));

    resetSelection(seedKeys);
    compile(rawFiles, getChapterOrEpisodeType(type), type);
  };

  useEffect(() => {
    if (type !== "Pesquisa") {
      getAttachmentsProjects();
    }
    getAttachmentsActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!stateProjectAttachment.loading && !stateActivityAttachment.loading) {
      // makeActiveAttachments()
      setActiveAttachments(stateProjectAttachment.files);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateProjectAttachment, stateActivityAttachment]);

  return (
    <div>
      <EditModalActivity
        files={stateFiles}
        filesAttachment={stateActivityAttachment.files}
        toggleActiveCheckBox={toggleActiveCheckBox}
        toggleActiveVersionCheckBox={toggleActiveVersionCheckBox}
        listAttachments={() => setStateSelectFiles(true)}
        clearActive={clearActive}
        type={type}
        _getActvity={_getActvity}
        currentActivity={currentActivity}
        open={open}
        loading={
          !!stateActivityAttachment.loading && !!stateProjectAttachment.loading
        }
        contentInfo={stateContentInfo}
      />

      {stateSelectFiles && (
        <SimpleScriptBox
          open={stateSelectFiles}
          title="Selecionar anexos"
          icon={<AttachmentIcon />}
          removePadding={true}
          resizeHeader={true}
          toggleScriptBox={() => setStateSelectFiles(false)}
        >
          <AddAttachments
            files={stateFiles}
            toggleActiveCheckBox={toggleActiveCheckBox}
            toggleActiveVersionCheckBox={toggleActiveVersionCheckBox}
            clearActive={clearActive}
            closedModal={() => setStateSelectFiles(false)}
            contentFormat={stateContentInfo.info.format}
          />
        </SimpleScriptBox>
      )}
    </div>
  );
};

export default EditActivity;
